<template>
  <modal ref='attachFileModal'>
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('upload_files_modal.upload_files') }}</h5>
    </template>

    <template #body>
      <div class='modal-body'>
        <dropzone ref='dropzone' :successCallback='uppySuccessCallback' :completeCallback='uppyCompleteCallback' :uppyClass="'UppyDragDropSend'"/>
      </div>
    </template>
  </modal>
</template>

<script>
import _modal from './_modal'
import _dropzone from './_dropzone'

export default {
  components: {
    'modal': _modal,
    'dropzone': _dropzone
  },
  data() {
    return {
      folder: {},
      uploadedRecords: []
    }
  },
  methods: {
    open(folder) {
      this.folder = Object.assign({}, folder)
      this.$refs.dropzone.reset()
      this.$refs.attachFileModal.open()
    },
    uppySuccessCallback(file, res) {
      let params = {
        folder_id: this.folder.id,
        filename: file.name,
        mime_type: file.type,
        size: file.size,
        location: res.uploadURL
      }

      return this.store.createRecord(params).then((records) => {
        this.uploadedRecords.push(records.data)
        this.$emit('success')

        this.store.sendMetrics({name: 'create_file_attachments', params: this.$route.params, path: this.$route.fullPath})
      })
    },
    uppyCompleteCallback(data) {
      this.$refs.attachFileModal.close()

      let records = data.successful

      this.$emit("complete", this.uploadedRecords);

      if (records.length > 1) {
        this.store.createUploadFolderActivity(this.folder.id, {
          event: 'upload_file',
          count: records.length,
          user_id: this.currentUser.id
        })
      } else if (records.length === 1) {
        let record = this.uploadedRecords[0]
        this.store.createUploadFolderActivity(this.folder.id, {
          event: 'upload_file',
          record_id: record.id,
          user_id: this.currentUser.id
        })
      }
      this.uploadedRecords = []
    }
  }
}
</script>
